import React, { useCallback, useEffect } from 'react';

import { useGlobalSearchParams, useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import useEffectOnce from 'hooks/use-effect-once';
import { RunningExperiments, useExperiments } from 'state/experiments';
import { selectors, useAppSelector } from 'state/global-state';
import { routes } from 'utils/routing';

import {
  BadgeText,
  StyledBellIcon,
  StyledNotificationButton,
  UnreadNotificationBadge,
} from './styled';

const MAX_NOTIFICATIONS_IN_BADGE = 9;

export const NotificationsButton = () => {
  const { logExposure } = useExperiments();
  const router = useRouter();
  const queryParams = useGlobalSearchParams();
  const { formatMessage } = useIntl();
  const unreadContentCards = useAppSelector(selectors.loyalty.selectUnreadContentCards);

  const logExperimentExposure = useCallback(() => {
    logExposure(RunningExperiments.NotificationCenterTest);
  }, [logExposure]);

  const onOpenPanel = useCallback(() => {
    router.navigate(routes.notificationInbox);
  }, [router]);

  // Used for accessing the Inbox from the URL
  useEffect(() => {
    if (queryParams.news === 'true') {
      onOpenPanel();
    }
  }, [onOpenPanel, queryParams.news]);

  useEffectOnce(() => {
    logExperimentExposure();
  });

  return (
    <>
      <StyledNotificationButton
        variant={ActionButtonVariants.TEXT_ONLY}
        size={ActionButtonSizes.SMALL}
        testID="app-header-notification-cta"
        onPress={onOpenPanel}
        startIcon={<StyledBellIcon />}
        accessibilityLabel={formatMessage({ id: 'news' })}
      >
        {unreadContentCards > 0 && (
          <UnreadNotificationBadge>
            <BadgeText>
              {unreadContentCards > MAX_NOTIFICATIONS_IN_BADGE
                ? `${MAX_NOTIFICATIONS_IN_BADGE}+`
                : unreadContentCards}
            </BadgeText>
          </UnreadNotificationBadge>
        )}
      </StyledNotificationButton>
    </>
  );
};
